/* RESPONSIBLE TEAM: team-conversations */
/* === ⚠️ THIS FILE CURRENTLY USES DEPRECATED PATTERNS ⚠️ === */
/* === 🔗 For more information visit https://go.inter.com/ember-best-practices 🔗 */
/* === 🚀 Please consider refactoring & removing some of the comments below when working on this file 🚀 */
/* eslint-disable ember/no-controller-access-in-routes */
/* eslint-disable ember/no-classic-classes */
import { inject as service } from '@ember/service';
import Route from '@ember/routing/route';
export default Route.extend({
  store: service(),
  analytics: {
    section: 'csv_imports',
    place: 'mapping',
  },

  activate() {
    this.controllerFor('apps/app/import/csv').set('currentStep', 2);
  },

  model(params) {
    return this.store.findRecord('csv-import', params.id);
  },
});
